import React from 'react';
import {OrbitComponent} from '../../components/base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {MAIN_SCREEN} from '../../themes/css-global-classes';
import {CyClass} from "../../../common/cy-classes";

@observer
export class MainScreenComponent extends OrbitComponent<{}> {

    render() {
        //TODO - main-screen class should be removed once we convert all the components to styled-components

        return (
          <div className={`${MAIN_SCREEN} ${CyClass('cy-main-screen')}`}>
              {this.props.children}
          </div>
        );
    }
}

